import React from 'react'

export default function ActivityIcon() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" className='opacity-70'>
            <path
                d="M7.5 1c.41 0 .75.34.75.75V3h7.5V1.75c0-.41.34-.75.75-.75s.75.34.75.75V3h.5C19.55 3 21 4.46 21 6.25v11.5c0 1.8-1.46 3.25-3.25 3.25H6.25C4.45 21 3 19.54 3 17.75V6.25C3 4.45 4.46 3 6.25 3h.5V1.75c0-.41.34-.75.75-.75ZM6.25 4.5c-.97 0-1.75.78-1.75 1.75V7.5h15V6.25c0-.97-.78-1.75-1.75-1.75H6.25ZM4.5 17.75c0 .97.78 1.75 1.75 1.75h11.5c.97 0 1.75-.78 1.75-1.75V9h-15v8.75ZM14 13c-.55 0-1 .45-1 1v3c0 .55.45 1 1 1h3c.55 0 1-.45 1-1v-3c0-.55-.45-1-1-1h-3Z">
            </path>
        </svg>
    )
}
